import { isEmpty, keys, mapValues, omitBy, pickBy } from 'lodash';

import { ActiveFacetsType, SelectedFacets } from '../constants';

export const formatSelectedFacets = (
  facets: ActiveFacetsType
): SelectedFacets =>
  omitBy(
    mapValues(facets, value => keys(pickBy(value))),
    isEmpty
  );
